import { observable } from 'mobx';
import moment from 'moment';
import type { Moment } from '../../lib/moment';

export type KitElementResponseArgs = {
  id: number;
  name: string;
  stock_number?: string;
  kind?: string;
  started_at?: string;
  ended_at?: string;
  kit_size?: number;
  lot_number?: string;
  remark?: string;
};

export type KitElementArgs = {
  id: number;
  name: string;
  stockNumber?: string;
  kind?: string;
  startedAt?: Moment;
  endedAt?: Moment;
  kitSize?: number;
  lotNumber?: string;
  remark?: string;
};

export const convertKitElementResponseToArgs = (response: KitElementResponseArgs) => {
  const args: KitElementArgs = {
    id: response.id,
    name: response.name,
    stockNumber: response.stock_number,
    kind: response.kind,
    startedAt: response.started_at ? moment(response.started_at) : undefined,
    endedAt: response.ended_at ? moment(response.ended_at) : undefined,
    kitSize: response.kit_size,
    lotNumber: response.lot_number,
    remark: response.remark
  };
  return args;
};

export default class KitElement {
  @observable id: number;
  @observable name: string;
  @observable stockNumber?: string;
  @observable kind?: string;
  @observable startedAt?: Moment;
  @observable endedAt?: Moment;
  @observable kitSize?: number;
  @observable lotNumber?: string;
  @observable remark?: string;

  constructor(args: KitElementArgs) {
    this.id = args.id;
    this.name = args.name;
    this.stockNumber = args.stockNumber;
    this.kind = args.kind;
    this.startedAt = args.startedAt;
    this.endedAt = args.endedAt;
    this.kitSize = args.kitSize;
    this.lotNumber = args.lotNumber;
    this.remark = args.remark;
  }

  get type() {
    return 'kit';
  }

  get title() {
    return '新型コロナ検査キット';
  }

  get summary() {
    return '[新型コロナ検査キット]';
  }

  detail() {
    return '';
  }

  validationErrors(_orderItemStatus?: number): string[] {
    const errors: string[] = [];

    if (!this.stockNumber || this.stockNumber === '') {
      errors.push('在庫管理番号を入力してください。');
    }

    return errors;
  }

  get updateParams() {
    return {
      type: this.type,
      name: this.name,
      kind: this.kind,
      started_at: this.startedAt?.format('YYYY-MM-DD HH:mm:ss'),
      ended_at: this.endedAt?.format('YYYY-MM-DD HH:mm:ss'),
      kit_size: this.kitSize,
      stock_number: this.stockNumber,
      lot_number: this.lotNumber,
      remark: this.remark
    };
  }

  get description(): string {
    return `<新型コロナ検査キット>
■数量：　${this.kitSize} 個
■備考
${this.remark}`;
  }

  get startTime() {
    return this.startedAt;
  }

  get endTime() {
    return this.endedAt;
  }
}
